import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { sagaActions } from "../../store/sagaActions";

const ExportReport = () => {
    const dispatch = useDispatch();
    const alumniDetails = useSelector(state => state.alumni);
    const { data: alumniData, error } = alumniDetails;
    const [exportData, setExportData] = useState([]);

  const headers = [
    { label: "Full Name", key: "full_name" },
    { label: "Email", key: "email" },
    { label: "Contact Number", key: "contact_number" },
    { label: "WhatsApp Number", key: "whatsapp_number" },
    { label: "Membership ID", key: "membership_id" },
    { label: "Membership Type", key: "membership_type" },
    { label: "Ticket Status", key: "ticket_status" },
    { label: "Attendance Status", key: "attendance_status" },
    { label: "Total Amount", key: "total_amount" },
    { label: "Accompany Count", key: "accompany_count" },
    { label: "Food Preference", key: "food_preference" },
    { label: "Passed Out Year", key: "passed_out_year" },
    { label: "College Name", key: "college_name" }
  ];

  useEffect(() => {
    if (alumniData.length === 0 && error === '') {
      dispatch({ type: sagaActions.FETCH_ALUMNI_DATA });
    }
  }, [dispatch, alumniData.length, error]);

  useEffect(() => {
    let simplifiedList = [];
    alumniData.forEach((data) => {
      const {
        full_name,
        email,
        whatsapp_number,
        contact_number,
        accompany_count = 0,
        total_amount = 0,
        ticket_status: { description: ticket_status = "" } = {},
        food_preference: { food_preference = "" } = {},
        membership_type: { membership_type = "" } = {},
        attendance_status: { description: attendance_status = "" } = {},
        passed_out_year: { year_name: passed_out_year = "" } = {},
        college: { college_name = "" } = {},
        membership_id = "",
      } = data;

      simplifiedList.push({
        full_name,
        email,
        whatsapp_number,
        contact_number,
        accompany_count,
        total_amount,
        ticket_status,
        attendance_status,
        food_preference,
        passed_out_year,
        membership_type,
        membership_id,
        college_name
      });
    });

    setExportData(simplifiedList);
  }, [alumniData]);

  return (
    <CSVLink data={exportData} headers={headers} filename={"registration-data.csv"}>
      <div className="report-button">Download Report</div>
    </CSVLink>
  );
};

export default ExportReport;